import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Column, Row, cls, Button } from '../../../packages/components';
import {applyOutLineFocus} from "../../Focus/utils";

class SeasonsNumber extends Component {
    constructor(props = {}) {
        super(props);
        this.state = {
            seasonNumber: 0,
            seasons: []
        };
    }

    componentDidMount = () => {
        this.addListener();
    };

    componentWillReceiveProps(nextProps){
        const {seasonNumber = null,seasons = []} = nextProps;
        this.setState({seasonNumber, seasons});
    }

    addListener = () => {
        const x = Array.from(
            document.getElementsByClassName('aaf-main-modal-options-seasons-main')
        );
        if (x && Array.isArray(x) && x[0]) {
            const element = x[0];
            element && typeof element.addEventListener === 'function' && element.addEventListener('sn:focused', this.hasFocused);
        }
    };

    hasFocused = (e) => {
        if (
            e &&
            e.detail &&
            e.detail.direction &&
            (e.detail.direction === 'right' || e.detail.direction === 'left')
        ) {
            if (e.target && e.target.parentNode) {
                const parent = e.target.parentNode;
                if (parent && typeof parent.scrollIntoView === 'function') {
                    parent.scrollIntoView();
                }
            }
        }
    };

    onChangeSeason = (season) =>{
        this.props.changeSeason(season);
    }

    onFocusSeason = (season) => {
        const { number: season_number = '' } = season;
        const seasonElement = document.getElementById(`season_${season_number}`)
        const rightMax = 1200;
        const LeftMin = 0;
        const seasonContainer = document.getElementsByClassName('aaf-main-modal-options-seasons-main')[0];

        if (seasonElement && seasonContainer){
            const [firstElement, ...rest] = seasonElement.getClientRects() || [];
            const {left, right} = firstElement;

            if (right>rightMax){
                seasonContainer.scrollLeft = seasonContainer.scrollLeft - (rightMax - right);
            }

            if (left < LeftMin) {
                seasonContainer.scrollLeft = 0;
            }
        }
    }

    render() {
        const {seasonNumber = null,seasons = []} = this.state;
      const classOutLineFocus = applyOutLineFocus();

      return (
            <Row className={cls(`aaf-main-modal-options-seasons-main`)}>
                {
                    seasons && Array.isArray(seasons) && seasons.map((season, idx) => {
                        return(
                            <div className={cls(`aaf-main-modal-options-div-seasons`)} id={`season_${season.number}`} key={idx}>
                                <Button
                                    id={`season_temp_${idx}`}
                                    className={cls(`button-seasons-default aaf-main-modal-options-button-seasons`,
                                                ((season.number === seasonNumber) ? 'aaf-main-modal-options-button-seasons-current': ''), `focusable`, `${classOutLineFocus}`)}
                                    onClick={() =>{this.onChangeSeason(season)}}
                                    onFocus={()=>{this.onFocusSeason(season)}}
                                >
                                    {`Temporada ${season.number || ''}`}
                                </Button>
                            </div>
                        )
                    })
                }
            </Row>
        );
    }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SeasonsNumber);



// WEBPACK FOOTER //
// ./src/components/EpisodeSelection/components/SeasonsNumber.jsx